











import {
  defineComponent,
  PropType,
  useContext,
  computed
} from '@nuxtjs/composition-api'
// @ts-ignore
import Item from '~/components/portfolios/Item'
import Paginator, {
  PaginationHeaders,
  calculateTotalFromHeaders
} from '~/components/Paginator.vue'
import { getPortfolioThumbnailUrl } from '~/libs/portfolios'

export default defineComponent({
  components: {
    Paginator,
    Item
  },
  props: {
    data: {
      type: Array as PropType<Portfolio[]>,
      required: true
    },
    headers: {
      type: Object as PropType<PaginationHeaders>,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    emptyText: {
      type: String,
      default: '該当するコンテンツはありません。'
    }
  },
  setup(props) {
    const { $auth } = useContext()

    // components/portfolios/Item を使えるようにデータの内容を変換
    const portfolios = computed(() =>
      props.data.map((portfolio: Portfolio) => ({
        id: portfolio.id,
        image_url: getPortfolioThumbnailUrl(portfolio),
        title: portfolio.title,
        genres: portfolio.genre_names,
        apps: portfolio.apps.map((app: Tag) => app.name),
        likes_count: portfolio.likes_count,
        clips_count: portfolio.clips_count,
        liking_uids: portfolio.liked ? [$auth.user?.id] : [],
        clipping_uids: portfolio.clipped ? [$auth.user?.id] : [],
        article: {
          role: portfolio.role_names.join('、'),
          camera: portfolio.camera_names.join('、'),
          client: portfolio.client
        },
        user: {
          username: portfolio.user.username,
          id: portfolio.user.id,
          nickname: portfolio.user.nickname,
          profile_image: portfolio.user.profile_image.thumb_160.url
        }
      }))
    )

    const total = computed(() => calculateTotalFromHeaders(props.headers))

    return {
      portfolios,
      total
    }
  }
})
